import Cookies from "js-cookie";
import React from "react";
import { Outlet } from "react-router-dom";
import LoadingToRedirect from "./LoadingToRedirect";

const AdminRoute = () => {
    let admin = Cookies.get('user');

    return admin ? <Outlet /> : <LoadingToRedirect />;
}

export default AdminRoute